<template>
	<div class="finance container-fluid py-3">
		<div class="row">
			<div class="col-md-12 mb-2">
				<h4>FINANCE REPORT</h4>
			</div>

			<div class="col-md-12">
				<el-card shadow="never" class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '8px', paddingRight: '8px', paddingTop: '8px' }">
					<div slot="header" class="clearfix" v-if="false">
						<span><strong>FINANCIAL REPORT</strong></span>
					</div>
					<div>
						<div class="mb-3">
							<el-tabs v-model="tabIndex" @tab-click="handleTabClick">
								<el-tab-pane :label="item.label" :name="item.index" v-for="(item, index) in tabListCustomerReport" :key="index+'-'+item.name" >
									<CustomerReportTab :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label"/>
								</el-tab-pane>

								<el-tab-pane :label="item.label" :name="item.index" v-for="(item, index) in tabListVendorReport" :key="index+'-'+item.name" >
									<VendorReportTab :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label"/>
								</el-tab-pane>

								<el-tab-pane :label="item.label" :name="item.index" v-for="(item, index) in tabListFinanceReport" :key="index+'-'+item.name" >
									<FinanceReportTab :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label"/>
								</el-tab-pane>

							</el-tabs>
						</div>
					</div>
				</el-card>
			</div>
		</div>
	</div>
</template>

<script>

import Customer from '@/components/page/Customer.js'
import CustomerReportTab from '@/views/pages/CustomerReportTab.vue'
import VendorReportTab from '@/views/pages/VendorReportTab.vue'
import FinanceReportTab from '@/views/pages/FinanceReport/FinanceReportTab.vue'

export default
{
	extends: Customer,
	components: {
		CustomerReportTab,
		VendorReportTab,
		FinanceReportTab,
	},

	data(){
		return {
			tabIndex: this.$route.query.tab ? this.$route.query.tab : '0',

			tabListCustomerReport:[
				{label:'Sales B2B', name: 'sales_b2b', index: '0' },
				{label:'Piutang', name: 'piutang', index: '1' },
				{label:'Progress Piutang', name: 'progress_piutang', index: '2' },
			],

			tabListVendorReport:[
				{label:'Hutang', name: 'hutang', index: '10' },
				{label:'Progress Hutang', name: 'progress_hutang', index: '11' },
			],

			tabListFinanceReport:[
				{label:'Cash Deposit Clearing', name: 'clearingcash', index: '20' },
				//{label:'Kliring VA Pangkalan LPG', name: 'clearingvalpg', index: '21' },
				{label:'Kliring EDC', name: 'clearingedc', index: '22' },
			],
		}
	},
	watch:
	{
		//area() { this.resumePilihan() },
		//status(){ this.resumePilihan() },
	},
    mounted()
    {
        this.$emit('childrenRoute');
    },
    methods:{
		handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },

    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


</style>
